import { __decorate, __param } from 'tslib';
import { CommonModule } from '@angular/common';
import { Inject, Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { BaseService, ErrorMessageService, MaskService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeNAccountProxy, ConfigService, UiPxDashboardModule } from '@wlp/ui-px-dashboard';

let UserBankInfoService = class UserBankInfoService extends BaseService {
    constructor(speNAccountProxy, storage, configService, errorMessageService, maskService, param) {
        super(storage, configService);
        this.speNAccountProxy = speNAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.maskService = maskService;
    }
    getUserBank() {
        this.speNAccountProxy
            .getUserBankInfo(this.keyPreAccount)
            .subscribe(data => {
            // balance = data;
        }, err => this.errorMessageService.getError(err));
        this.userBank = {
            accountNumber: '123456-7',
            agency: '0001',
            bank: 'PSXBank',
            digit: '093',
            userEmail: 'rafaela.rago@payshopx.com.br',
            userName: 'Rafaela',
            userCompleteName: 'Rafaela Targino Rago',
        };
        return this.userBank;
    }
};
UserBankInfoService.ctorParameters = () => [
    { type: SpeNAccountProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService },
    { type: MaskService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_PARAMETER,] }] }
];
UserBankInfoService = __decorate([
    Injectable(),
    __param(5, Inject(APP_PARAMETER))
], UserBankInfoService);

var UiBsDashboardModule_1;
let UiBsDashboardModule = UiBsDashboardModule_1 = class UiBsDashboardModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsDashboardModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsDashboardModule.ctorParameters = () => [
    { type: UiBsDashboardModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsDashboardModule = UiBsDashboardModule_1 = __decorate([
    NgModule({
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            UiPxDashboardModule,
            UiBsUtilModule,
            RxReactiveFormsModule
        ],
        providers: [
            UserBankInfoService,
        ],
        exports: [RxReactiveFormsModule]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsDashboardModule);

class UserBankInfoResponse {
}

/*
 * Public API Surface of ui-bs-dashboard
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiBsDashboardModule, UserBankInfoResponse, UserBankInfoService };
//# sourceMappingURL=wlp-ui-bs-dashboard.js.map
